/* eslint-disable no-prototype-builtins */
/* eslint-disable no-console */
/* eslint-disable no-shadow */
/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-restricted-syntax */
/* eslint-disable prefer-destructuring */
/* eslint-disable react/jsx-props-no-spreading */
import queryString from "query-string";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
// import { Box } from "@mui/material";
import { Helmet } from "react-helmet";
import EmptyFileIcon from "../../../assets/svg/EmptyFile";
import ReloadIcon from "../../../assets/svg/ReloadIcon";
import SearchIconWithPeople from "../../../assets/svg/SearchIconWithPeople";
import AppliedFilter from "../../../components/common/AppliedFilter/AppliedFilter";
// import ExportButton from "../Components/ExportButton/ExportButton";
import Loader from "../../../components/common/Loader/Loader";
import Modal from "../../../components/common/Modal/Modal";
import Pagination from "../../../components/common/new/Pagination/Pagination";
import useUserConfig from "../../../hooks/useUserConfig";
import {
  DATES,
  EVENT_NAME,
  ACTIVE,
  Constants,
  AlertStatus,
  AppliedFilterLabelMapEmailer,
} from "../../../contants";
// import { MEMBER_SEARCH_COL } from "../../../contants/table/memberSearch";
import useParamsQuery from "../../../hooks/useParamsQuery";
import { SET_SELECTED_MEMBER_TRANSFER } from "../../../redux/actionTypes/dashboard";
import {
  selectAllSIUsers,
  selectOSKeysByUserRole,
} from "../../../redux/selectors/user";
// import Member from "../../../services/api/member";
import Reports from "../../../services/api/reports";
import { ROUTES } from "../../../utils/constants";
import { formDataToObject, isEmptyObj } from "../../../utils/helper";
import AdvancedSearch from "./AdvancedSearch";
import styles from "./EmailerReceipients.styles";
// import MemberTable from "./MemberTable/MemberTable";
import ReportTable from "../Components/EmailerTable/EmailerTable";
// import MemberToggleStatus from "./MemberToggleStatus/MemberToggleStatus";
import ReportToggleStatus from "../Components/ReportsToogleStatus/ReportsToggleStatus";
// import OrganizationSearch from "./OrganizationSearch";
import OrganizationSearch from "../Components/OrganizationSearch";
import PersonalDetailsSearch from "../Components/PersonalDetailsSearch";
import StatsCoordinatorStructure from "../Components/StatsCoordinatorStructure";
import Popover from "../Components/Popover/Popover";
import {
  getFilters,
  getFormattedQuery,
  getRoutePath,
  handleDependencyFilter,
  performOperation,
} from "./utils";
import { ToastAlertContext } from "../../../config/providers/ToastAlert";
import Dropdown from "../../../components/common/new/Dropdown/Dropdown";

const LOADER_DELAY = 1000;
const PAGE = "page";

const FILTER_KEYS = {
  ADVANCE_FILTER: "advance-filter",
  PERSONAL_FILTER: "personal-filter",
  ORGANISATION_STRUCTURE_FILTER: "orgainsation-structure-filter",
  STATS_COORDINATOR_FILTER: "stats-coordinator-filter",
};

const SEARCH_FILTERS = [
  {
    key: FILTER_KEYS.ADVANCE_FILTER,
    component: AdvancedSearch,
    popOverprops: {
      heading: "Advanced Search",
    },
  },
  {
    key: FILTER_KEYS.PERSONAL_FILTER,
    component: PersonalDetailsSearch,
    popOverprops: {
      heading: "Search by Personal Details",
    },
  },
  {
    key: FILTER_KEYS.ORGANISATION_STRUCTURE_FILTER,
    component: OrganizationSearch,
    popOverprops: { heading: "Organization Structure", minWidth: 413 },
  },
  // {
  //   key: FILTER_KEYS.STATS_COORDINATOR_FILTER,
  //   component: StatsCoordinatorStructure,
  //   popOverprops: { heading: "Stats Coordinator Structure", minWidth: 413 },
  // },
];

const OTHERS_FILTERS = [
  {
    key: FILTER_KEYS.ORGANISATION_STRUCTURE_FILTER,
    component: OrganizationSearch,
    popOverprops: { heading: "Organization Structure", minWidth: 413 },
  },
  {
    key: FILTER_KEYS.STATS_COORDINATOR_FILTER,
    component: StatsCoordinatorStructure,
    popOverprops: {
      heading: "Stats Coordinator Structure",
      minWidth: 413,
      minHeight: 50,
    },
  },
];

const ORGANISATION_FILTERS = [
  {
    key: FILTER_KEYS.ORGANISATION_STRUCTURE_FILTER,
    component: OrganizationSearch,
    popOverprops: { heading: "Organization Structure", minWidth: 413 },
  },
];

// const intialPaginationState = {
//   currentPage: 0,
//   totalPages: 0,
//   totalElements: 0,
//   pageSize: Constants.DEFAULT_PAGE_SIZE,
// };
const USERS_OPTIONS = [
  {
    value: "members",
    key: "Members",
  },
  {
    value: "planningBoard",
    key: "Planning Board",
  },
  {
    value: "honChairpersons",
    key: "Hon. Chairpersons",
  },
  {
    value: "stats_coordinator",
    key: "Stats Coordinator",
  },
];
const filterOrder = [
  "areaId",
  "zoneId",
  "regionId",
  "chapterId",
  "districtId",
  "blockId",
];
function EmailerRecipients() {
  const TITLE = "Select Email Recipients - BSG";
  const [searchData, setSearchData] = useState([]);
  const [appliedFilters, setAppliedFilters] = useState([]);
  // const [paginationInfo, setPaginationInfo] = useState(intialPaginationState);
  const [isLoading, setIsLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  const formRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const metaData = useSelector((state) => state.meta);
  const disabledOSKeys = useSelector(selectOSKeysByUserRole);
  const { isHelpDesk, isHelpDeskAdmin } = useSelector(selectAllSIUsers);
  const hasPermission = useUserConfig();
  const { getQueryObject, getQueryParams, urlSearchParams } = useParamsQuery();
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [pageSize, setPageSize] = useState(Constants.DEFAULT_PAGE_SIZE);
  const [user, setUser] = useState(USERS_OPTIONS[0].value);
  const toast = useContext(ToastAlertContext);
  const onModalToggle = () => setOpenModal((prev) => !prev);
  const [contactType, setContactType] = useState(null);

  // const updatePaginationInfo = (pagination) => {
  //   setPaginationInfo({
  //     currentPage: pagination.number,
  //     totalPages: pagination.totalPages,
  //     totalElements: pagination.totalElements,
  //     pageSize: pagination.size,
  //   });
  // };

  const clearFormRef = () => {
    Object.keys(AppliedFilterLabelMapEmailer).forEach((key) => {
      if (formRef.current[key]) {
        formRef.current[key].value = "";
        formRef.current[key]?.blur();
      }
    });
  };

  const resetFormState = () => {
    setSearchData([]);
    setAppliedFilters([]);
    // setPaginationInfo(intialPaginationState);
    clearFormRef();
  };

  const initializeFormState = (queryObject) => {
    if (!isEmptyObj(queryObject)) {
      clearFormRef();
      Object.keys(queryObject).forEach((key) => {
        if (formRef.current[key]) {
          formRef.current[key].value = queryObject[key];
        }
      });
    }
  };

  const updateSearchParam = (query) => {
    if (query?.length) {
      navigate(`${getRoutePath()}?${query}`);
    } else {
      navigate(`${getRoutePath()}`);
    }
  };

  const removeKeyFromQuery = (queryObject, filterKey) => {
    let updatedQuery = {
      ...queryObject,
      pageNumber: 0,
      pageSize: Constants.DEFAULT_PAGE_SIZE,
    };
    console.log(filterKey);
    console.log(updatedQuery);

    if (DATES.includes(filterKey)) {
      delete updatedQuery[filterKey];
      delete updatedQuery[`${filterKey.split("From")[0]}To`];
    } else {
      delete updatedQuery[filterKey];
    }

    if (Object.keys(updatedQuery).length === 1 && PAGE in updatedQuery) {
      delete updatedQuery[PAGE];
    }

    // handle dependency filter
    updatedQuery = handleDependencyFilter(updatedQuery, disabledOSKeys);

    return updatedQuery;
  };

  const onRemoveFilter = (filterKey) => {
    // console.log(filterKey);
    // setPaginationInfo(intialPaginationState);
    let queryObject = getQueryObject();
    queryObject = removeKeyFromQuery(queryObject, filterKey);
    const updatedQuery = queryString.stringify(queryObject);
    updateSearchParam(updatedQuery);
  };

  // const validateAndFetchData = (formattedQuery, toast, setIsLoading) => {
  //   if (
  //     !formattedQuery.hasOwnProperty("areaId") ||
  //     formattedQuery.areaId === ""
  //   ) {
  //     toast.show("Please enter Area", AlertStatus.ERROR);
  //     setIsLoading(false);
  //     return false;
  //   }

  //   return true;
  // };

  useEffect(() => {
    if (user === "planningBoard" || user === "honChairpersons") {
      setContactType(user);
    } else {
      setContactType(null);
    }
  }, [user]);

  const fetchSearchData = async (
    queryParams,
    pageNumber = 0,
    pageSize = Constants.DEFAULT_PAGE_SIZE
  ) => {
    try {
      setIsLoading(true);
      const updatedQueryParams = { ...queryParams };

      updatedQueryParams.contactType = contactType;
      const formattedQuery = getFormattedQuery({
        // ...queryParams,
        ...updatedQueryParams,
        pageNumber,
        pageSize,
      });

      // if (validateAndFetchData(formattedQuery, toast, setIsLoading)) {
      const { data } = await Reports.searchMemberReports(formattedQuery);

      // Showing some delay to avoid loader flicker issue
      setTimeout(() => {
        setSearchData(data.content);
        setCurrentPage(data.number);
        setTotalPages(data.totalPages);
        setTotalElements(data.totalElements);
        setPageSize(pageSize);
        setIsLoading(false);
      }, LOADER_DELAY);
      // }
    } catch (error) {
      setIsLoading(false);
      toast.show(
        error.message || "Something went wrong. Please contact support.",
        AlertStatus.ERROR
      );
      console.error(error);
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    // setPaginationInfo(intialPaginationState);

    // Extract form values using formRef
    const rawFormData = new FormData(formRef.current);
    const formData = formDataToObject(rawFormData);
    formData.pageNumber = 0;
    formData.pageSize = Constants.DEFAULT_PAGE_SIZE;
    const query = queryString.stringify(formData);

    if (user === "honChairpersons" || user === "planningBoard") {
      fetchSearchData(formData);
    }

    // Close all popover
    document.dispatchEvent(new Event(EVENT_NAME));
    updateSearchParam(query); // it will trigger below useEffect
  };

  useEffect(() => {
    const queryObject = getQueryObject();
    if (!isEmptyObj(queryObject)) {
      const [query, params] = getQueryParams(queryObject);
      fetchSearchData(query, params.pageNumber, params.pageSize);
      initializeFormState(query);
    } else {
      resetFormState();
    }
    // resetFormState();
  }, [urlSearchParams.toString()]);

  useEffect(() => {
    const queryObject = getQueryObject();
    if (!isEmptyObj(queryObject)) {
      const query = getQueryParams(queryObject)[0];
      setAppliedFilters(getFilters(query, metaData, disabledOSKeys));
    }
  }, [metaData, urlSearchParams.toString()]);

  const onPaginationClick = (clickedNumber) => {
    const queryObject = getQueryObject();
    const queryParams = queryString.stringify({
      ...queryObject,
      pageNumber: clickedNumber,
    });
    updateSearchParam(queryParams);
  };

  const onPageSizeClick = (operator) => {
    const queryObject = getQueryObject();
    const queryParams = queryString.stringify({
      ...queryObject,
      pageNumber: 0,
      pageSize: queryObject.pageSize
        ? performOperation(
            queryObject.pageSize,
            Constants.DEFAULT_PAGE_SIZE,
            operator
          )
        : 2 * Constants.DEFAULT_PAGE_SIZE,
    });
    updateSearchParam(queryParams);
  };

  const onSelectMemberForTransfer = (member) => {
    dispatch({
      type: SET_SELECTED_MEMBER_TRANSFER,
      payload: member,
    });
    navigate(ROUTES.MEMBER_TRANSFER_REQUEST.path);
  };

  const onSelectMember = (member) => {
    navigate(`/${ROUTES.REPORTS_MEMBER.path}/${member.memberId}`);
  };

  const onMemberStatusToggle = (member) => {
    setSelectedMember(member);
    onModalToggle();
  };

  const getTitle = () =>
    selectedMember?.status === ACTIVE
      ? "Reason for deactivating the user?"
      : "Reactivation";

  const onRefresh = () => {
    const queryObject = getQueryObject();
    const [query, params] = getQueryParams(queryObject);
    fetchSearchData(query, params);
  };

  const clearAllFilter = () => {
    updateSearchParam();
  };
  const orderedFilters = filterOrder
    .map((filterKey) =>
      appliedFilters.find((filter) => filter.key === filterKey)
    )
    .filter(Boolean);

  const additionalFilters = appliedFilters.filter(
    (filter) => !filterOrder.includes(filter.key)
  );
  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <div style={styles.container}>
        {/* <Box
      sx={{
        background: "rgb(207, 227, 255)",
        height: "50px",
        marginBottom: "30px",
      }}
    >
      <p style={{ textAlign: "center", padding: "13px", margin: "0 auto" }}>
        Template 1
      </p>
    </Box> */}
        <div style={styles.filter}>
          <Dropdown
            name="Users"
            value={user}
            options={USERS_OPTIONS}
            label="Select Contacts Type"
            containerStyle={{ width: "20%" }}
            onChange={(selectedValue) => {
              if (!selectedValue) {
                setUser("");
              } else {
                setUser(selectedValue.target.value);
              }
            }}
          />
          {user === "members" ? (
            <form style={styles.left} onSubmit={onSubmit} ref={formRef}>
              {SEARCH_FILTERS.map(
                ({ component: Component, popOverprops, key }) => (
                  <Popover key={key} {...popOverprops}>
                    <Component
                      formRef={formRef}
                      disabledOSKeys={disabledOSKeys}
                    />
                  </Popover>
                )
              )}
            </form>
          ) : user === "planningBoard" ? (
            <form style={styles.left} onSubmit={onSubmit} ref={formRef}>
              {ORGANISATION_FILTERS.map(
                ({ component: Component, popOverprops, key }) => (
                  <Popover key={key} {...popOverprops}>
                    <Component
                      formRef={formRef}
                      disabledOSKeys={disabledOSKeys}
                    />
                  </Popover>
                )
              )}
            </form>
          ) : user === "honChairpersons" ? (
            <form style={styles.left} onSubmit={onSubmit} ref={formRef}>
              {ORGANISATION_FILTERS.map(
                ({ component: Component, popOverprops, key }) => (
                  <Popover key={key} {...popOverprops}>
                    <Component
                      formRef={formRef}
                      disabledOSKeys={disabledOSKeys}
                    />
                  </Popover>
                )
              )}
            </form>
          ) : (
            <form style={styles.left} onSubmit={onSubmit} ref={formRef}>
              {OTHERS_FILTERS.map(
                ({ component: Component, popOverprops, key }) => (
                  <Popover key={key} {...popOverprops}>
                    <Component
                      formRef={formRef}
                      disabledOSKeys={disabledOSKeys}
                    />
                  </Popover>
                )
              )}
            </form>
          )}
          <div style={styles.right}>
            {/* <ExportButton
      data={searchData}
      exportFunction={Reports.downloadMembersReport}
      columnHeadingList={MEMBER_SEARCH_COL}
      fileName="member_report"
    /> */}
            <div style={styles.reload} onClick={onRefresh}>
              <ReloadIcon />
            </div>
          </div>
        </div>
        <div style={styles.main}>
          {searchData?.length ? (
            <div style={styles.totalElements}>
              Total Members: {totalElements}
            </div>
          ) : null}
          {appliedFilters.length ? (
            <div style={styles.filterWrapper}>
              <div style={styles.filterContainer}>
                {/* {appliedFilters.map((filter) => (
              <AppliedFilter
                key={filter.key}
                filter={filter}
                onRemove={onRemoveFilter}
              />
            ))} */}
                {orderedFilters.map((filter) => (
                  <AppliedFilter
                    key={filter.key}
                    filter={filter}
                    onRemove={onRemoveFilter}
                  />
                ))}
                {additionalFilters.map((filter) => (
                  <AppliedFilter
                    key={filter.key}
                    filter={filter}
                    onRemove={onRemoveFilter}
                  />
                ))}
              </div>
              <div style={styles.clearAll} onClick={clearAllFilter}>
                Clear
              </div>
            </div>
          ) : null}
          {searchData?.length ? (
            <>
              <ReportTable
                searchData={searchData}
                currentPage={currentPage}
                pageSize={pageSize}
                onSelectMemberForTransfer={onSelectMemberForTransfer}
                onSelectMember={onSelectMember}
                hasPermission={hasPermission}
                onMemberStatusToggle={onMemberStatusToggle}
                showStatusColumn={isHelpDesk || isHelpDeskAdmin}
                user={
                  user === "planningBoard" || user === "honChairpersons"
                    ? user
                    : null
                }
              />
              <div style={styles.pagination}>
                {/* <div style={styles.totalSize}>
              Number of Members found: {paginationInfo.totalResults}
            </div> */}
                <Pagination
                  totalPages={totalPages}
                  totalResults={totalElements}
                  currentPage={currentPage}
                  pageSize={pageSize}
                  onChange={onPaginationClick}
                  onPageSizeClick={onPageSizeClick}
                />
              </div>
            </>
          ) : (
            <div style={styles.initialContent}>
              {appliedFilters.length ? (
                <>
                  <EmptyFileIcon width={100} />
                  <span style={styles.text}>
                    No data found with current Filters
                  </span>
                </>
              ) : (
                <>
                  <SearchIconWithPeople width={100} />
                  <span style={styles.text}>Choose your Search Filter</span>
                </>
              )}
            </div>
          )}
        </div>
        {isLoading && <Loader />}
        <Modal open={openModal} onClose={onModalToggle} title={getTitle()}>
          <ReportToggleStatus
            selectedMember={selectedMember}
            onClose={onModalToggle}
            callBack={onRefresh}
          />
        </Modal>
      </div>
    </>
  );
}

export default EmailerRecipients;
